import { Box, Modal, ModalProps } from "@mantine/core";
import { displayClasses } from "styles";

const CustomModal = (props: ModalProps) => (
  <Modal
    centered={true}
    withCloseButton={true}
    overlayProps={{
      backgroundOpacity: 0.55,
      blur: 3,
    }}
    {...props}
  >
    <Box className={displayClasses.modalBody}>
      {props.children}
    </Box>
  </Modal>
)

export default CustomModal;